import { connectBaseApi, createRpcQuery, createRpcMutation, blacklistClient } from "@racoon/api";

const blacklistApi = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listBlacklists: createRpcQuery(build, blacklistClient, "listBlacklists", {
      providesTags: ["Blacklist"],
    }),

    createBlacklist: createRpcMutation(build, blacklistClient, "createBlacklist", {
      invalidatesTags: ["Blacklist"],
    }),

    deleteBlacklist: createRpcMutation(build, blacklistClient, "deleteBlacklist", {
      invalidatesTags: ["Blacklist"],
    }),
  }),
  overrideExisting: false,
});

export const { useListBlacklistsQuery, useCreateBlacklistMutation, useDeleteBlacklistMutation } =
  blacklistApi;
